import { Chess } from 'chess.js';

/** SAN moves from a PGN (empty if invalid). */
export function sanMovesFromPgn(pgn: string): string[] {
  const temp = new Chess();
  try {
    temp.loadPgn(pgn);
    return temp.history();
  } catch {
    return [];
  }
}

/** Apply the first `moveIndex` moves of `moves` to a reset board. */
export function positionAfterMoves(moves: string[], moveIndex: number): Chess {
  const chess = new Chess();
  const n = Math.max(0, Math.min(moveIndex, moves.length));
  for (let i = 0; i < n; i++) {
    const san = moves[i]!;
    const played = chess.move(san);
    if (!played) break;
  }
  return chess;
}
